
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/login",
      function () {
        return require("private-next-pages/[lang]/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/login"])
      });
    }
  